export type AppPage =
  | 'home'
  | 'pinyin-learning'
  | 'pinyin-table'
  | 'pinyin-module'
  | 'pinyin-index'
  | 'resources-download'
  | 'tone-learning'
  | 'product-info'
  | 'terms'
  | 'privacy'
  | 'contact'
  | 'chengyu-learning'
  | 'chengyu-stage'
  | 'chengyu-idiom'
  | 'chengyu-flashcards'
  | 'chengyu-dictionary'
  | 'chengyu-game-puzzle'
  | 'chengyu-games'
  | 'chengyu-game-fill'
  | 'chengyu-game-solitaire'
  | 'character-free'
  | 'character-recognize'
  | 'character-recognize-level'
  | 'character-recognize-detail'
  | 'character-handwrite'
  | 'character-handwrite-level'
  | 'character-handwrite-detail'
  | 'character-goal'
  | 'character-goal-learn'
  | 'character-goal-review'
  | 'vocabulary-book'
  | 'learned-words'
  | 'mastered-words'
  | 'vocab-goal'
  | 'vocab-learn'
  | 'vocab-difficult-words'
  | 'vocab-learned-words'
  | 'vocab-mastered-words'

export const pageUrls: Partial<Record<AppPage, string>> = {
  home: '/',
  'pinyin-learning': '/pinyin-learning',
  'pinyin-table': '/pinyin-table',
  'pinyin-module': '/pinyin-module',
  'pinyin-index': '/pinyin-index',
  'resources-download': '/resources-download',
  'tone-learning': '/tone-learning',
  'product-info': '/product-info',
  terms: '/terms',
  privacy: '/privacy',
  contact: '/contact',
  'chengyu-learning': '/chengyu-learning',
  'chengyu-flashcards': '/chengyu-flashcards',
  'chengyu-dictionary': '/chengyu-dictionary',
  'chengyu-game-puzzle': '/chengyu/games/puzzle',
  'chengyu-games': '/chengyu/games',
  'chengyu-game-fill': '/chengyu/games/fill',
  'chengyu-game-solitaire': '/chengyu/games/solitaire',
  'character-free': '/characters/free',
  'character-recognize': '/characters/recognize',
  'character-handwrite': '/characters/handwrite',
  'character-goal': '/characters/goal',
  'character-goal-learn': '/characters/goal/learn',
  'character-goal-review': '/characters/goal/review',
  'vocabulary-book': '/vocabulary-book',
  'learned-words': '/learned-words',
  'mastered-words': '/mastered-words',
  'vocab-goal': '/vocab',
  'vocab-learn': '/vocab/learn',
  'vocab-difficult-words': '/vocab/difficult-words',
  'vocab-learned-words': '/vocab/learned-words',
  'vocab-mastered-words': '/vocab/mastered-words',
}

export const getPageFromPath = (path: string): AppPage => {
  if (path === '/pinyin-learning') {
    return 'pinyin-learning'
  } else if (path === '/pinyin-table') {
    return 'pinyin-table'
  } else if (path === '/pinyin-module') {
    return 'pinyin-module'
  } else if (path === '/pinyin-index') {
    return 'pinyin-index'
  } else if (path === '/resources-download') {
    return 'resources-download'
  } else if (path === '/tone-learning') {
    return 'tone-learning'
  } else if (path === '/product-info') {
    return 'product-info'
  } else if (path === '/terms') {
    return 'terms'
  } else if (path === '/privacy') {
    return 'privacy'
  } else if (path === '/contact') {
    return 'contact'
  } else if (path === '/chengyu-learning') {
    return 'chengyu-learning'
  } else if (path.startsWith('/chengyu/stage/')) {
    return 'chengyu-stage'
  } else if (path.startsWith('/chengyu/idiom/')) {
    return 'chengyu-idiom'
  } else if (path === '/chengyu-flashcards') {
    return 'chengyu-flashcards'
  } else if (path === '/chengyu-dictionary') {
    return 'chengyu-dictionary'
  } else if (path === '/chengyu/games/puzzle') {
    return 'chengyu-game-puzzle'
  } else if (path === '/chengyu/games') {
    return 'chengyu-games'
  } else if (path === '/chengyu/games/fill') {
    return 'chengyu-game-fill'
  } else if (path === '/chengyu/games/solitaire') {
    return 'chengyu-game-solitaire'
  } else if (path === '/characters/free') {
    return 'character-free'
  } else if (path === '/characters/recognize') {
    return 'character-recognize'
  } else if (path.match(/\/characters\/recognize\/hsk\/[^/]+\/detail\//)) {
    return 'character-recognize-detail'
  } else if (path.startsWith('/characters/recognize/hsk/')) {
    return 'character-recognize-level'
  } else if (path.startsWith('/characters/recognize/detail/')) {
    return 'character-recognize-detail'
  } else if (path === '/characters/handwrite') {
    return 'character-handwrite'
  } else if (path.match(/\/characters\/handwrite\/hsk\/[^/]+\/detail\//)) {
    return 'character-handwrite-detail'
  } else if (path.startsWith('/characters/handwrite/hsk/')) {
    return 'character-handwrite-level'
  } else if (path.startsWith('/characters/handwrite/detail/')) {
    return 'character-handwrite-detail'
  } else if (path === '/characters/goal') {
    return 'character-goal'
  } else if (path === '/characters/goal/learn') {
    return 'character-goal-learn'
  } else if (path === '/characters/goal/review') {
    return 'character-goal-review'
  } else if (path === '/vocabulary-book') {
    return 'vocabulary-book'
  } else if (path === '/learned-words') {
    return 'learned-words'
  } else if (path === '/mastered-words') {
    return 'mastered-words'
  } else if (path === '/vocab') {
    return 'vocab-goal'
  } else if (path === '/vocab/learn') {
    return 'vocab-learn'
  } else if (path === '/vocab/difficult-words') {
    return 'vocab-difficult-words'
  } else if (path === '/vocab/learned-words') {
    return 'vocab-learned-words'
  } else if (path === '/vocab/mastered-words') {
    return 'vocab-mastered-words'
  }

  return 'home'
}
